module.exports = {"TXTWCL_Browse_tournaments":{"id":"TXTWCL_Browse_tournaments","defaultMessage":"Показать турниры","track":"Browse tournaments"}}